import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'

export const Tabs: ComponentStyleConfig = {
  variants: {
    default: (props: Dict) => ({
      tablist: {
        borderBottom: '1px solid',
        borderColor: mode(
          'rw1.secondary.light.2',
          'rw1.secondary.dark.2',
        )(props),
      },
      tab: {
        borderBottom: '4px solid',
        borderColor: 'transparent',
        marginBottom: '-2px',
        color: mode('rw1.text.light.1', 'rw1.text.dark.1')(props),
        fontWeight: 600,
        _selected: {
          color: mode('rw1.primary.light.5', 'rw1.primary.dark.5')(props),
          borderColor: mode(
            'rw1.secondary.light.5',
            'rw1.secondary.dark.5',
          )(props),
          borderBottom: '4px solid',
        },
        _hover: {
          borderBottom: '4px solid',
          borderColor: mode(
            'rw1.secondary.light.5',
            'rw1.secondary.dark.5',
          )(props),
          color: mode('rw1.text.light.1', 'rw1.text.dark.1')(props),
        },
        _disabled: {
          opacity: 0.4,
          cursor: 'not-allowed',
        },
        _focus: {
          boxShadow: 'none',
        },
      },
    }),
  },
  defaultProps: {
    variant: 'default',
  },
}
